export default __webpack_public_path__ + "static/media/bajaj.21d577d1.png";